import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialContactFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import ContactFilterData from "./ContactFilterData";

const ContactFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialContactFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain(filterData);
    setIsSidebarOpen(false);
  };

  const saveSearchFilterData = {
    first_name: filterData?.first_name,
    last_name: filterData?.last_name,
    email: filterData?.email,
    company: filterData?.company,
    property: filterData?.property,
    phone: filterData?.phone,
    street_address: filterData?.street_address,
    city: filterData?.city,
    state: filterData?.state,
    zip_code: filterData?.zip,
    leadsource_id: filterData?.leadsource_id,
    website: filterData?.website,
    first_deal_anniversary: filterData?.first_deal_anniversary,
    has_acquisition: filterData?.has_acquisition,
    tax_record_sent: filterData?.tax_record_sent,
    tax_record_sent_date: filterData?.tax_record_sent_date,
    tax_record_start_date: filterData?.tax_record_start_date,
    tax_record_end_date: filterData?.tax_record_end_date,
    tag_category: filterData?.tag_category,
    tags: filterData?.tags,
    withoutTags: filterData?.withoutTags,
    last_contact: filterData?.last_contact,
    lastContactSentDate: filterData?.lastContactSentDate,
    lastContactSentSdate: filterData?.lastContactSentSdate,
    lastContactSentEdate: filterData?.lastContactSentEdate,
    date_category: filterData?.date_category,
    within_last_day: filterData?.within_last_day,
    longer_than_day: filterData?.longer_than_day,
    count: filterData?.count,
    start_count: filterData?.start_count,
    end_count: filterData?.end_count,
    activity_count: filterData?.activity_count,
    activity_start_count: filterData?.activity_start_count,
    activity_end_count: filterData?.activity_end_count,
    interaction_type: filterData?.interaction_type,
    interaction_type_user: filterData?.interaction_type_user,
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      first_name: value?.first_name ?? "",
      last_name: value?.last_name ?? "",
      email: value?.email ?? "",
      company: value?.company?.id == null ? { id: "", name: "" } : value?.company,
      property: value?.property ?? "",
      phone: value?.phone ?? "",
      street_address: value?.street_address ?? "",
      city: value?.city ?? "",
      state: value?.state ?? "",
      zip_code: value?.zip_code ?? "",
      leadsource_id: value?.leadsource_id ?? [],
      website: value?.website ?? "",
      first_deal_anniversary: value?.first_deal_anniversary ?? "",
      has_acquisition: value?.has_acquisition ?? "",
      tax_record_sent: value?.tax_record_sent ?? "",
      tax_record_sent_date: value?.tax_record_sent_date ?? "",
      tax_record_start_date: value?.tax_record_start_date ?? "",
      tax_record_end_date: value?.tax_record_end_date ?? "",
      tags: value?.tags ?? [],
      withoutTags: value?.withoutTags ?? [],
      tag_category: value?.tag_category ?? "with",
      last_contact: value?.last_contact ?? "date",
      lastContactSentDate: value?.lastContactSentDate ?? "",
      lastContactSentSdate: value?.lastContactSentSdate ?? "",
      lastContactSentEdate: value?.lastContactSentEdate ?? "",
      date_category: value?.date_category ?? "days",
      within_last_day: value?.within_last_day,
      longer_than_day: value?.longer_than_day,
      interaction_type_user: value?.interaction_type_user,
      count: value?.count ?? "",
      start_count: value?.start_count ?? "",
      end_count: value?.end_count ?? "",
      activity_count: value?.activity_count,
      activity_start_count: value?.activity_start_count,
      activity_end_count: value?.activity_end_count,
      interaction_type: value?.interaction_type ?? "",
    };
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);

    localStorage.setItem("searchfilterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    console.log('searchfilterData', dataToSet)
    onCallApiAgain(dataToSet);


  };


  return (
    <div>
      <SavedFilterComponent
        from="contact"
        filterType="basic"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialContactFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={setSelectedSaveFilterId}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={setIsSidebarOpen}
      />


      <RightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Filter"
        from="contact"
        desc="Enter Contact information."
        onFilter={handleFilter}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
      >
        <ContactFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} onSetFilterData={onSetFilterData} />
      </RightModal>
    </div>
  );
};

export default ContactFilter;
